module.exports = __webpack_public_path__ + "img/banner.970b651d.png";